import { useMedicalEventAction } from './useActions'
import { Box, Grid2 as Grid, styled, Typography } from '@mui/material'
import InputBase from 'design-system/input/base'
import React from 'react'
import ButtonBase from 'design-system/button'
import { MEDICAL_EVENTS } from 'navigation/CONSTANTS'
import NavLinkBack from 'components/NavLinkBack'
import ConfirmationModal from 'components/ConfirmationModal'

const StyledBox = styled(Box)(() => ({
  maxWidth: '1200px',
  padding: '20px 10% 90px 10%',
  width: '100%',
  justifyContent: 'center',
  alignSelf: 'center'
}))

const MedicalEventActionPage: React.FC = () => {
  const {
    change,
    data,
    editMode,
    errorsMap,
    onSubmit,
    state,
    disableFields,
    enableButton,
    openEditModal,
    setOpenEditModal
  } = useMedicalEventAction()

  return (
    <StyledBox>
      <Grid container>
        <Grid size={12} paddingBlock={2}>
          <NavLinkBack to={`/${MEDICAL_EVENTS}`} title='Eventos Médicos' />
        </Grid>
      </Grid>
      <Typography variant='h5' padding={'20px 0px'}>
        {!editMode ? 'Cadastro de evento médico' : 'Alterar evento médico'}
      </Typography>
      <Grid container justifyContent={'center'} spacing={4}>
        <InputBase
          label='Nome do evento'
          required
          variant='outlined'
          value={data.event_name}
          disabled={disableFields}
          onChange={e => change('event_name', e.target.value)}
          error={errorsMap.has('event_name')}
          helperText={errorsMap.get('event_name')}
        />
        <InputBase
          label='Descrição'
          variant='outlined'
          value={data.description ?? ''}
          onChange={e => change('description', e.target.value)}
          disabled={disableFields}
          error={errorsMap.has('description')}
          helperText={errorsMap.get('description')}
        />
      </Grid>
      <Grid size={12} justifyContent={'end'} container>
        <ButtonBase
          variant='contained'
          type='submit'
          sx={{ mt: 2 }}
          disabled={!enableButton || state == 'loading'}
          loading={state == 'loading'}
          onClick={editMode ? () => setOpenEditModal(true) : onSubmit}
        >
          {editMode ? 'Editar evento médico' : 'Cadastrar evento médico'}
        </ButtonBase>
      </Grid>

      <ConfirmationModal
        open={openEditModal}
        title='Essa ação afetará os registros já cadastrados para os pacientes, deseja continuar?'
        onConfirm={onSubmit}
        onCancel={() => setOpenEditModal(false)}
        actionContainer={{ justifyContent: 'center', paddingTop: '16px' }}
      />
    </StyledBox>
  )
}

export default MedicalEventActionPage
